/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [user-info.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 28.02.20, 22:33
 */

import React, {useState} from 'react';
import HtmlTextToggler from "../../toggler/html-text-toggler";
import {formatFns, useLanguage} from "../../configuration/configuration";
import {asStaticExternalUrlList} from "../../util/text-utils";
import {useAuthorization} from "../../../selectors";
import {RoundedButton} from "../../navigation/buttons/nav-buttons";
import UpdateStatusDialog from "../../dialogs/user/update-status-dialog";
import {NavigationGroup, NavigationRow} from "../../navigation/layout/nav-layout";
import {
    ArrowRightIcon,
    BusinessCenterIcon,
    CakeIcon,
    FavoriteIcon,
    LocationIcon,
    MegaphoneIcon,
    SchoolIcon,
    UserPenIcon,
    fs_bigger, fs_regular, fs_large
} from "../../navigation/icons/nav-icons";

const UserInformation = ({userdata, user, space, isOwner=false, className, ...otherProps}) => {
    const [showUpdateStatusDialog, setShowUpdateStatusDialog] = useState(false);
    const {isAuthorized} = useAuthorization();
    const Lang = useLanguage();
    const birthday = formatFns(new Date(userdata.birthday), 'd MMMM');

    const relationship = () => {
        switch (userdata.relationship) {
            case 'SINGLE':
                return Lang.user.relationship.single
            case 'ENGAGED':
                return Lang.user.relationship.engaged
            default:
                return Lang.user.relationship.none
        }
    }

    const handleOnStatusUpdate = (event) => {
        event.preventDefault();
        setShowUpdateStatusDialog(true);
    }

    const isRelationship = userdata.relationship !== 'NONE';
    return <div {...otherProps}>
        <NavigationRow className='generic-navigation-information d-flex align-content-between al mb-2'>
            <NavigationGroup>
                <div>
                    <MegaphoneIcon size={fs_bigger} className="mr-2"/>
                    <span className='generic-user-quote-text'>{userdata.status}</span>
                    <HtmlTextToggler text={space.description} fullview={true}/>
                </div>
            </NavigationGroup>
            <NavigationGroup>
                {isAuthorized && isOwner &&
                    <RoundedButton title={Lang.user.updateStatus} onClick={handleOnStatusUpdate}>
                        <UserPenIcon size={fs_regular} className='font-user-pen clr-blue'/>
                    </RoundedButton>}
            </NavigationGroup>
        </NavigationRow>

        {showUpdateStatusDialog &&
            <UpdateStatusDialog user={user} isOpen={showUpdateStatusDialog} setIsOpen={setShowUpdateStatusDialog}/>}

        <div className='generic-navigation-information mb-2'>
            <div><LocationIcon size={fs_regular} className='mr-2'/>
                {Lang.user.currentLocation(user.firstname, userdata.address.city)}
            </div>
            {userdata.work &&
                <div><BusinessCenterIcon size={fs_regular} className="mr-2"/>{userdata.work}</div>}
            {userdata.studies &&
                <div><SchoolIcon size={fs_regular} className="mr-2"/>{userdata.studies}</div>}
            <div><CakeIcon size={fs_regular} className="mr-2"/>{Lang.user.hasBirthdayOn(birthday)}</div>
            {isRelationship &&
                <div><FavoriteIcon size={fs_regular} className="clr-red mr-2"/>{relationship()}</div>}
        </div>
        <div className='generic-navigation-information'>
            {userdata && <div>
                <HtmlTextToggler icon={<ArrowRightIcon size={fs_large}/>}
                                 title={`${Lang.user.about} ${user.firstname}`} text={userdata.aboutYou}
                                 fullview={true}/>
                <HtmlTextToggler icon={<ArrowRightIcon size={fs_large}/>}
                                 title={Lang.user.politics} text={userdata.politics}/>
                <HtmlTextToggler icon={<ArrowRightIcon size={fs_large}/>}
                                 title={Lang.user.web} text={asStaticExternalUrlList(userdata.web)} fullview/>
            </div>}
        </div>
    </div>
};

export default UserInformation;